<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import {deviceApi} from '@router/apiFiles/deviceApi'

export default {
  page: {
    title: 'Device search',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      tableData: [],
      isBusy: true,
      title: 'Device Telemetry',
      modemIdentifier: '',
      items: [],

      fields: [
        {key: 'parameter', label: 'Parameter', sortable: false},
        {key: 'lastValidValueDateTime', label: 'Last Valid Value DateTime', sortable: false},
        {key: 'lastValidValue', label: 'Last Valid Value', sortable: false},
        {key: 'lastValueDateTime', label: 'Last Value DateTime', sortable: false},
        {key: 'lastValue', label: 'Last Value', sortable: false},
      ],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    splitDateTime(fullDateTime) {
      if (!fullDateTime) return ''
      const parts = fullDateTime.split('T');
      const date = parts[0];
      const timeParts = parts[1].split(':');
      const hour = timeParts[0];
      const minute = timeParts[1];

      return `${date} ${hour}:${minute}`;
    },

    fetchData() {
      deviceApi.getDeviceTelemetryValues({id: this.$route.params.id})
          .then((response) => {
            response.data.forEach((item) => {
              item._rowVariant = this.rowClass(item.lastValidValueDateTime)
              item.lastValidValueDateTime = this.splitDateTime(item.lastValidValueDateTime)
              item.lastValueDateTime = this.splitDateTime(item.lastValueDateTime)
            })
            this.tableData = response.data
            this.isBusy = false
            this.modemIdentifier = response.modemIdentifier
          })
    },
    rowClass(dateString) {

      if (!dateString) return '';
      //return 'warning'
      const now = new Date();
      const lastDate = new Date(dateString);
      const hoursDifference = (now - lastDate) / (1000 * 60 * 60);

      if (hoursDifference > 72 && hoursDifference < 730) return 'warning';
      if (hoursDifference > 730) return 'danger';
      return '';
    },
  }

}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <b-card>
      <h4>Modem Identifier: {{ modemIdentifier }}</h4>
      <!-- Table -->
      <div class="table-responsive mb-0">
        <div class="table-responsive mb-0">
          <b-table
              :items="tableData"
              :fields="fields"
              responsive="sm"
              :per-page="100"
              show-empty
              empty-text="No matching records found"
              :busy="isBusy"
              hover

          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner variant="primary" class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style scoped lang="scss">

</style>